<!--
 * @Description: 大成钱柜资产详情
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="bizcomp-money-box">
        <div class="money-box-header">
            <div class="money-box-header-left">
                <div class="header-left-content">
                    <div class="money-text">
                        大成钱柜
                        <span class="money-text-yuan">(元)</span>
                    </div>
                    <div class="money-num">
                        {{ $util.fmtNum(xjbInfo.xjbasset) }}
                    </div>
                    <div class="money-btn-contain">
                        <div class="money-btn" v-on:click="toCurrencyCharge()">充值</div>
                        <div class="money-btn margin-10" v-on:click="toCurrencyRedemption()">
                            取现
                        </div>
                        <div class="money-btn" v-on:click="toAutoAccess()">自动存取</div>
                    </div>
                </div>
            </div>
            <div class="money-box-header-right">
                <div class="header-right-content">
                    <div class="right-content1">
                        <div class="yesterday-earning">
                            <div class="header-text">昨日收益(元)</div>
                            <div class="header-num">
                                {{ $util.fmtNum(xjbInfo.xjblastprofit) }}
                            </div>
                        </div>
                        <div class="accumulated-earning">
                            <div class="header-text">累计收益(元)</div>
                            <div class="header-num">
                                {{ $util.fmtNum(xjbInfo.xjbtotalprofit) }}
                            </div>
                        </div>
                    </div>
                    <div class="right-content2">
                        <div class="header-text">七日年化</div>
                        <div class="header-num">{{ $util.fmtNum(xjbInfo.growthrate) }}%</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="money-box-advance">
            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-title">大成钱柜优势</div>
            </div>
            <div class="card-contain">
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-1-1.svg" alt="" />
                    </div>
                    <div class="card-text">实时取现</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-1-2.svg" alt="" />
                    </div>
                </div>
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-2-1.svg" alt="" />
                    </div>
                    <div class="card-text">0折购基</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-2-2.svg" alt="" />
                    </div>
                </div>
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-3-1.svg" alt="" />
                    </div>
                    <div class="card-text">闲钱理财</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-3-2.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "MoneyBox",
    mixins: [mixin],
    data() {
        return {
            xjbInfo: {}
        };
    },
    mounted() {
        this.getAssetsInfo();
    },
    methods: {
        toCurrencyCharge() {
            this.$router.push({ name: "currencycharge" });
        },
        toCurrencyRedemption() {
            this.$router.push({ name: "currencyredemption" });
        },
        toAutoAccess() {
            this.$router.push("/autoaccess");
        },
        async getAssetsInfo() {
            const res = await fundApi.getHoldingAssets({});
            if (res.data && res.data.first) {
                this.xjbInfo = res.data.first;
                this.xjbInfo.growthrate = res.data.returnList[0].growthrate;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-box {
    width: 1200px;
    margin-bottom: 20px;
    .money-box-header {
        width: 1200px;
        display: flex;
        height: 210px;
        border-radius: 12px;
        background: linear-gradient(260deg, #f2fbff 0%, #ffefec 100%);
        box-sizing: border-box;
        border: 2px solid #f1f1f1;
        .money-box-header-left {
            width: 600px;
            height: 210px;
            padding: 30px 0 44px 70px;
            box-sizing: border-box;
            .header-left-content {
                .money-text {
                    height: 24px;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 23.4px;
                    color: #333333;
                    .money-text-yuan {
                        height: 14px;
                        font-size: 16px;
                        font-weight: normal;
                        color: #666666;
                        margin-left: 4px;
                    }
                }
                .money-num {
                    margin-top: 20px;
                    height: 28px;
                    font-size: 32px;
                    font-weight: 500;
                    color: #333333;
                }
                .money-btn-contain {
                    display: flex;
                    margin-top: 32px;
                    .money-btn {
                        width: 106px;
                        text-align: center;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 2px;
                        box-sizing: border-box;
                        color: #e60012;
                        border: 1px solid #e60012;
                        cursor: pointer;
                    }
                    .money-btn:hover {
                        background: #e60012;
                        color: #ffffff;
                    }
                }
            }
        }
        .money-box-header-right {
            padding: 30px 0 49px 0;
            .header-right-content {
                padding-left: 70px;
                border-left: 1px solid #eeeeee;
                .right-content1 {
                    display: flex;
                    .accumulated-earning {
                        margin-left: 209.48px;
                    }
                }
                .right-content2 {
                    margin-top: 31px;
                }
            }
        }
    }
    .money-box-advance {
        width: 1200px;
        padding-bottom: 20px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
        margin-top: 20px;
        .bar-contain {
            height: 60px;
            display: flex;
            align-items: center;
            background: #ffffff;
            border: 1px solid #f1f1f1;
            .bar {
                width: 3.71px;
                height: 16px;
                background: #e60012;
                margin: 0 6.5px 0 19px;
            }
            .bar-title {
                font-size: 18px;
                font-weight: 500;
                color: #333333;
            }
        }
        .card-contain {
            display: flex;
            justify-content: space-around;
            margin-top: 20px;
            .card-content {
                width: 380px;
                height: 150px;
                border-radius: 6px;
                background: #f9f9f9;
                display: flex;
                align-items: center;
                .card-img1 {
                    margin-left: 50px;
                }
                .card-text {
                    margin-left: 10.3px;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #333333;
                }
                .card-img2 {
                    margin-left: 50px;
                }
            }
        }
    }
    .margin-10 {
        margin: 0 10px;
    }
    .header-text {
        height: 14px;
        font-size: 14px;
        font-weight: normal;
        line-height: 14px;
        color: #666666;
    }
    .header-num {
        margin-top: 8px;
        height: 28px;
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        color: #e60012;
    }
}
</style>
